import qs from 'qs'
import axios from 'axios'
import * as login from './modules/login'
import * as active from './modules/activeCard'
import * as tabs from './modules/tabs'
import * as shoppingCar from './modules/shoppingCar'
import * as orderList from './modules/order'
import * as collageList from './modules/collage'
import * as address from './modules/address'
import * as util from './modules/util'
import * as afterSales from './modules/after-sales'
import * as eventTracking from './modules/eventTracking'
import * as common from './modules/common'
import * as goods from './modules/goods'
import Vue from 'vue'
import { Toast } from 'vant'

import { $platformCode } from '@/common'

Toast.allowMultiple()
Vue.use(Toast)

const getUrlCode = function (code) {
  const search = window.location.search.substr(1)
  const rag = RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
  const result = search.match(rag)
  return result ? result[2] : null
}

const service = {
  state: {
    inited: false,
    user: null
  },
  init(cb) {
    this.getLoginType()
      .then((res) => {
        const loginType = res.data.loginType
        let data = {}
        if (loginType) {
          data.loginType = loginType
        }
        this.userinfo(data)
          .then((result) => {
            if (result.code === 200 && result.data) {
              this.state = {
                inited: true,
                user: result.data
              }
              // 初始化神策 distinct_id
              sensors.login(result.data.ccOpenId)
            }
            cb(this.state)
          })
          .catch((error) => {
            cb()
          })
      })
      .catch((error) => {
        Toast({
          type: 'fail',
          message: error.message
        })
        cb()
      })
  },
  fetch({
    method = 'get',
    url,
    isReturntype = 0,
    scope = 'snsapi_base',
    data,
    params,
    isJSON = true,
    isState = true,
    platformCode = '',
    errorHandle = null // 订单详情-查询拼团的时候可能不存在拼团,此时不能报错
  }) {
    let defaultLoading
    if (isState) {
      defaultLoading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 10000
      })
    }

    url = process.env.VUE_APP_TITLE === 'production' ? `/${url}` : `/api/${url}`
    const options = {
      method: method.toUpperCase(),
      url,
      headers: {
        tenantId: $platformCode
      },
      isReturntype: isReturntype,
      data: isJSON ? data : typeof data === 'string' ? data : qs.stringify(data),
      scope: scope,
      params,
      isState
    }
    if (platformCode) {
      const parameter = options.method === 'GET' ? 'params' : 'data'
      options[parameter] = options.method === 'GET'
        ? JSON.parse(JSON.stringify(options.params || {}))
        : JSON.parse(JSON.stringify(options.data || {}))
    }

    const handleResponse = (result) => {
      const data = result.data
      if (defaultLoading) {
        defaultLoading.clear()
      }
      // isReturntype === 1 除帐号信息失效不返回其它都返回 code 400101 400102  400103
      // isReturntype === 2 所有状态都正常返回业务端
      // isReturntype === 0 只有200正常返回
      if (
        (options.isReturntype === 1 &&
          data.code !== 400101 &&
          data.code !== 400102 &&
          data.code !== 400103) ||
        options.isReturntype === 2
      ) {
        return data
      } else {
        if (data.code !== 200) {
          if (data.code === 400101 || data.code === 400201) {
            let url = encodeURIComponent(window.location.href)
            let defalutCode = null
            if (data.code === 400101) {
              defalutCode = getUrlCode('code') || getUrlCode('app_code')
            }
            return this.getToken().then((res) => {
              if (defalutCode) {
                return this.accredit({
                  appId: res.data.appId,
                  code: defalutCode,
                  scope: options.scope
                }).then(() => {
                  return axios(options).then(handleResponse)
                })
              } else {
                window.location.href = `http://wx.coocaa.com/weixin.htm?appid=${res.data.appId}&redirect_uri=${url}&scope=${options.scope}&state=`
              }
            })
          } else if (data.code === 500) {
            return data.message
          } else if (data.code === 400) {
            return data
          }
          // 400102是登录失效,不能拦截 400103-未注册
          if (!errorHandle || data.code === 400102 || data.code === 400103) {
            throw result
          } else {
            errorHandle(data)
          }
        }
        return data
      }
    }
    return axios(options).then(handleResponse)
  },
  ...util,
  ...login,
  ...active,
  ...tabs,
  ...shoppingCar,
  ...orderList,
  ...collageList,
  ...address,
  ...afterSales,
  ...eventTracking,
  ...common,
  ...goods
}

export default service
